if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
			this.modalContent.innerHTML = '';

			if (preventFocus) this.openedBy = null;
			super.hide();
		}

		show(opener) {
			opener.setAttribute('aria-disabled', true);
			opener.classList.add('loading');

			if (opener.querySelector('.loading-overlay__spinner')) {
				opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
			}

			// Always load the base product page so a stale ?variant= sold-out ID is not forced in.
			const productUrl = (opener.getAttribute('data-product-url') || '').split('?')[0];

			fetch(productUrl)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
					this.preventDuplicatedIDs();
					this.removeDOMElements();
					this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();

					this.removeGalleryListSemantic();
					this.updateImageSizes();
					this.preventVariantURLSwitching();
					this.ensureQuickViewAvailableVariant();
					super.show(opener);
				})
				.finally(() => {
					opener.removeAttribute('aria-disabled');
					opener.classList.remove('loading');

					if (opener.querySelector('.loading-overlay__spinner')) {
						opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
					}

					var slider = new Swiper('.quick-add-modal .js-media-list', {
						slidesPerView: 1,
						autoHeight: true,
						navigation: {
							nextEl: '.swiper-btn--next',
							prevEl: '.swiper-btn--prev',
						},
						pagination: {
							el: ".swiper-pagination",
							clickable: true,
						},
						on: {
							slideChange: function () {
								window.pauseAllMedia();
							}
						}
					});

					function fallbackCopyTextToClipboard(text) {
						const textarea = document.createElement('textarea')
						textarea.value = text
						textarea.style.position = 'fixed'
						document.body.appendChild(textarea)
						textarea.focus()
						textarea.select()
						try {
							const successful = document.execCommand('copy')
							return successful
						} catch (err) {
							return false
						} finally {
							document.body.removeChild(textarea)
						}
					}

					function copyLink(e, copyButton) {
						e.preventDefault()
						e.stopPropagation()
						const url = copyButton.getAttribute('href');

						const handleCopy = (btn, success) => {
							if (success) {
								btn.classList.add('copied')
								setTimeout(() => {
									btn.classList.remove('copied')
								}, 1000)
							} else {
								btn.classList.add('notCopied')
								setTimeout(() => {
									btn.classList.remove('notCopied')
								}, 1000)
							}
						}

						if (window.Shopify && window.Shopify.designMode) {
							const success = fallbackCopyTextToClipboard(url)
							handleCopy(copyButton, success)
						} else {
							navigator.clipboard.writeText(url).then(
								() => {
									handleCopy(copyButton, true)
								},
								() => {
									handleCopy(copyButton, false)
								}
							)
						}
					}

					const copyButtons = document.querySelectorAll('.copy-btn')

					if (copyButtons.length) {
						for (const copyButton of copyButtons) {
							copyButton.addEventListener('click', (e) =>
								copyLink(e, copyButton)
							)
						}
					}

					document.addEventListener('shopify:section:load', function (event) {
						const copyButtons = document.querySelectorAll('.copy-btn')

						if (copyButtons.length) {
							for (const copyButton of copyButtons) {
								copyButton.addEventListener('click', (e) =>
									copyLink(e, copyButton)
								)
							}
						}
					})

					if ($('#search-modal').hasClass('active')) {
						$('#search-modal,.search-modal__mask').toggleClass('active');
					};
				});
		}

		setInnerHTML(element, html, opener) {
			element.innerHTML = html;

			// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
			element.querySelectorAll('script').forEach(oldScriptTag => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach(attribute => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});

			// Read more button
			const moreBtn = document.createElement('a');
			moreBtn.textContent = `${theme.quickviewMore}`;
			moreBtn.setAttribute('href', opener.getAttribute('data-product-url'));
			moreBtn.setAttribute('class', 'product__read-more button--simple full-unstyled-link h6');
			element.querySelector('.product__info-container').appendChild(moreBtn);
		}

		removeDOMElements() {
			const pickupAvailability = this.productElement.querySelector('pickup-availability');
			if (pickupAvailability) pickupAvailability.remove();

			const productModal = this.productElement.querySelector('product-modal');
			if (productModal) productModal.remove();

			const gift = this.productElement.querySelector('.customer');
			if (gift) gift.remove();
		}

		preventDuplicatedIDs() {
			const sectionId = this.productElement.dataset.section;
			this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
			this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
				variantSelect.dataset.originalSection = sectionId;
			});
		}

		preventVariantURLSwitching() {
			if (this.modalContent.querySelector('variant-radios,variant-selects')) {
				this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
			}
		}

		ensureQuickViewAvailableVariant() {
			const picker = this.modalContent.querySelector('variant-radios, variant-selects');
			if (!picker || typeof picker.ensureAvailableVariantSelected !== 'function') return;
			picker.ensureAvailableVariantSelected();
		}

		removeGalleryListSemantic() {
			const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
			if (!galleryList) return;

			galleryList.setAttribute('role', 'presentation');
			galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
		}

		updateImageSizes() {
			const product = this.modalContent.querySelector('.product');
			const desktopColumns = product.classList.contains('product--columns');
			if (!desktopColumns) return;

			const mediaImages = product.querySelectorAll('.product__media img');
			if (!mediaImages.length) return;

			let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

			if (product.classList.contains('product--medium')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '605px');
			} else if (product.classList.contains('product--small')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '495px');
			}

			mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
		}
	});
}
